// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__jLgfn","title":"InfoRow_title__3AC1x"};